import { Box, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

export const Root = styled('header')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.palette.tokens.space[4],
  flexWrap: 'wrap',
  marginBottom: theme.palette.tokens.space[8],
}));

export const TitleBlock = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '4px',
  minWidth: 0,
  marginRight: 'auto',
}));

export const Title = styled(Typography)<{ component?: string }>(
  ({ theme }) => ({
    ...theme.typography.h4,
    color: theme.palette.text.primary,
    margin: 0,
  })
);

export const Subtitle = styled(Typography)(({ theme }) => ({
  ...theme.typography.body2,
  color: theme.palette.text.secondary,
}));

export const Actions = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.palette.tokens.space[2],
  flexShrink: 0,
}));
